<template>
  <div class="form-group" :id="groupId" :class="classes">
    <slot name="label">
      <label :for="id" v-if="label && labelTop" :class="labelclass">{{
        label
      }}</label>
    </slot>
    <slot>
      <input
        :type="type"
        :id="id"
        :name="name"
        class="form-control nw-form"
        :class="{
          valid: mutableValue || parseInt(mutableValue) === 0 || valid,
        }"
        v-model="mutableValue"
        :disabled="disable"
        :readonly="readonly"
        :maxlength="maxlength"
        :placeholder="placeholder"
        @focus="$emit('focus')"
        @keyup="$emit('keyup')"
        @blur="$emit('blur')"
      />
    </slot>
    <slot name="append"></slot>
    <slot name="label">
      <label :for="id" v-if="label && !labelTop" :class="labelclass">{{
        label
      }}</label>
    </slot>
    <slot name="error">
      <div class="invalid-feedback mt-1 d-block" v-if="vErrors">
        {{ vErrors.first((scope ? scope + "." : "") + name) }}
      </div>
    </slot>
    <slot name="help"></slot>
    <slot name="showpass"></slot>
    <slot name="attribute"></slot>
  </div>
</template>

<script>
export default {
  props: {
    groupId: { default: "" },
    id: { default: Math.random() },
    value: { default: "" },
    label: { default: "" },
    labelclass: { default: "" },
    mainclass: { default: "" },
    name: { default: "" },
    scope: { default: "" },
    vErrors: { default: false },
    disable: { default: false },
    readonly: { default: false },
    valid: { default: false },
    maxlength: { default: "" },
    placeholder: { default: "" },
    type: { default: "text" },
    labelTop: { default: false },
  },
  data() {
    return {
      mutableValue: "",
    };
  },
  computed: {
    classes() {
      var classes = {
        "group-error":
          this.vErrors &&
          this.vErrors.has((this.scope ? this.scope + "." : "") + this.name),
      };
      classes[this.mainclass] = true;

      return classes;
    },
  },
  created() {
    this.mutableValue = this.value;
  },
  watch: {
    mutableValue(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.mutableValue = val;
    },
  },
};
</script>
